import { NewslineItem, NewslineSettings } from "../../../models/knowledgeBase/newsline"
import { UPDATE_ARTICLE_NEWSLINE_SETTINGS_FAILED_MESSAGE } from "../../../store/knowledgeBase/constants"
import { setNews, updateCurrentArticleNewslineSettings } from "../../../store/knowledgeBase/slice"
import { cacher } from "../../../utility/common/rtkQueryCacheUtils"
import { queryApi } from "../../api"
import { newslineTag } from "../../tags"
import { handleQueryApiError } from "../../utility/error"

export const newslineApi = queryApi.injectEndpoints({
    endpoints(build) {
        return {
            getNewsline: build.query<NewslineItem[], string>({
                query: projectId => ({
                    url: `${projectId}/newsline`,
                    method: "GET"
                }),
                providesTags(result, error, projectId) {
                    return cacher.cacheByIdArg(newslineTag)(result, error, projectId)
                },
                onQueryStarted(_, { dispatch, queryFulfilled }) {
                    queryFulfilled.then(({ data }) => {
                        dispatch(setNews(data))
                    })
                }
            }),
            updateArticleSettings: build.mutation<
                { ArticleId?: string },
                { projectId: string; symbolCode: string; articleId: string; settings: NewslineSettings }
            >({
                query: ({ projectId, symbolCode, articleId, settings }) => ({
                    url: `${projectId}/newsline/${symbolCode}/${articleId}`,
                    method: "PUT",
                    body: {
                        ...settings,
                        ArticleId: articleId
                    }
                }),

                async onQueryStarted({ settings }, { dispatch, queryFulfilled }) {
                    try {
                        const { data } = await queryFulfilled

                        dispatch(updateCurrentArticleNewslineSettings({ settings, articleId: data.ArticleId }))
                    } catch (e) {
                        handleQueryApiError(dispatch, UPDATE_ARTICLE_NEWSLINE_SETTINGS_FAILED_MESSAGE, e)
                    }
                }
            })
        }
    }
})

export const { useGetNewslineQuery, useUpdateArticleSettingsMutation } = newslineApi
